
import React from 'react';
import { CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserPlus } from 'lucide-react';

interface StudentsTabHeaderProps {
  onAddStudent: () => void;
}

const StudentsTabHeader = ({ onAddStudent }: StudentsTabHeaderProps) => {
  return (
    <CardHeader className="flex flex-row items-center justify-between">
      <CardTitle>Students</CardTitle>
      <Button variant="outline" onClick={onAddStudent} className="gap-1">
        <UserPlus className="h-4 w-4" />
        Add Student
      </Button>
    </CardHeader>
  );
};

export default StudentsTabHeader;
